
export const defaultOptions = {
    selectableRows: 'none',
    print: false,
    download: false,
    filter:true,
    filterType:"multiselect",
    responsive:'simple',
    rowsPerPageOptions: [25, 50, 75, 100],
    rowsPerPage: 25,
    textLabels: {
        body: {
            noMatch: "No records to display"
        }
    }
}
export const download100Pages = {
    selectableRows: 'none',
    print: false,
    download: true,
    filter:true,
    filterType:"multiselect",
    responsive:'simple',
    rowsPerPageOptions: [25, 50, 75, 100],
    rowsPerPage: 100,
    textLabels: {
        body: {
            noMatch: "No records to display"
        }
    }
}
export const noDownload100Pages = {
    selectableRows: 'none',
    print: false,
    download: false,
    filter:true,
    filterType:"multiselect",
    responsive:'simple',
    rowsPerPageOptions: [25, 50, 75, 100],
    rowsPerPage: 100,
    textLabels: {
        body: {
            noMatch: "No records to display"
        }
    }
}
export const defaultOptionsDownload = {
    selectableRows: 'none',
    print: false,
    download: true,
    filter:true,
    filterType:"multiselect",
    responsive:'simple',
    rowsPerPageOptions: [25, 50, 75, 100],
    rowsPerPage: 25,
    textLabels: {
        body: {
            noMatch: "No records to display"
        }
    }
}
export const ticketTableOptions = {
    selectableRows:'none',
    download:false,
    print:false,
    rowsPerPageOptions: [25, 50, 75, 100],
    rowsPerPage: 25,
    responsive:'simple',
    textLabels: {
        body: {
            noMatch: "No records to display"
        }
    },
    sortOrder:{
        name:'number',
        direction:'desc'
    }
}

export const smallTableOptions = {
    selectableRows:'none',
    download:false,
    print:false,
    rowsPerPageOptions: [25, 50, 75, 100],
    rowsPerPage: 25,
    responsive:'simple',
    tableBodyHeight:'100%',
    tableBodyMaxHeight:'40vh',
    textLabels: {
        body: {
            noMatch: "No records to display"
        }
    },
    sortOrder:{
        name:'number',
        direction:'desc'
    }
}

export const NRITableOptions ={
    print:false,
    selectableRows: 'none',
    rowsPerPageOptions: [25, 50, 75, 100],
    rowsPerPage: 25,
    responsive:'simple',
    textLabels: {
        body: {
            noMatch: "No records to display"
        }
    },
}